import React, { memo } from 'react';
export const CheckMark = memo(() => {
  return React.createElement("svg", {
    width: '17px',
    height: '13px',
    viewBox: '0 0 17 13',
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("g", {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }, React.createElement("g", {
    transform: 'translate(-2832.000000, -1103.000000)',
    stroke: '#FFFFFF',
    strokeWidth: '3'
  }, React.createElement("g", {
    transform: 'translate(2610.000000, 955.000000)'
  }, React.createElement("g", {
    transform: 'translate(24.000000, 91.000000)'
  }, React.createElement("g", {
    transform: 'translate(179.177408, 36.687816)'
  }, React.createElement("polyline", {
    points: '34.2767388 22 24.797043 31.4796958 21 27.6826527'
  })))))));
});